import { extendTheme, theme as defaultTheme } from '@chakra-ui/react';
import '@fontsource/ubuntu/300.css';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';

const breakpoints = {
  ...defaultTheme.breakpoints,
  tabletSmall: '37.5em', // 600px and above
  tabletLarge: '48em', // 768px and above
  desktop: '64em', // 1024px and above
  desktopLarge: '75em', // 1200px and above
};

const theme = extendTheme({
  breakpoints,
  colors: {
    primary: {
      50: '#f5e9f7',
      100: '#e6cce9',
      200: '#d6addc',
      300: '#c68ecf',
      400: '#b671c2',
      500: '#9b5ba4',
      600: '#804a88',
      700: '#65386c',
      800: '#4a2851',
      900: '#301836',
    },
    text: {
      main: '#1A202C',
      sub: '#757575',
    },
    background: '#EDF5FD',
    bgPrimary: '#E8F1FE',
    inactive: '#9AA2AB',
    secondary: '#E4A316',
  },
  fonts: {
    heading: `'Ubuntu', sans-serif`,
    body: `'Ubuntu', sans-serif`,
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 700,
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        py: '21px',
      },
    },
  },
});

export default theme;
